<div class="centered-text">
  The online lesson overview will launch you into the digital classroom platform
  and provide an overview of all current lessons and their participants
  statuses. You will be able to check on all aspects of attendance and also
  access the rooms to provide support.
</div>

<div class="centered-text">
  The platform will launch in a new tab so ensure it is not being blocked if it
  fails to open.
</div>

@if (OnlineOverviewClient) {
  <div class="button-container">
    @for (client of clients; track client; let i = $index) {
      <div class="button-wrapper">
        <div>
          <div>{{client.clientName }} {{client.clientId }}</div>
          <button class="btn btn-outline-primary btn--large" (click)="launchOnlineOverview(false, client.clientId, client.clientName)">Launch Online Overview</button>
        </div>
      </div>
    }
  </div>
}
<br />
@if (OnlineOverviewAllRooms) {
  <div class="button-container">
    <button class="btn btn-outline-primary btn--large" (click)="launchOnlineOverview(true)">
      Launch Online Overview
    </button>
  </div>
}
